import React from 'react';
import styles from '../DetailsCard/style.module.css';
import HealthCustomCard from '../../../../Components/HealthCustomCard';
import { usePatient } from '../../../../Contexts/PatientContext';
import * as moment from 'moment';

const LABELS = {
  currentSurgeryDate: 'Data da Cirurgia',
  tumorCid: 'CID Tumor',
  finalStaging: 'Estadiamento',
  treatmentProtocol: 'Protocolo de Tratamento',
  ecog: 'ECOG',
  hadRadiotherapy: 'Fez Radioterapia?',
  hadSystemicTherapy: 'Fez Terapia Sistêmica?',
  currentSurgeryType: 'Tipo de Cirurgia',
  accessRoutes: 'Via de Acesso',
  hasStoma: 'Tem Estoma?',
  hasDrain: 'Tem Dreno?',
  usesProphylacticAnticoagulant: 'Usa Anticoagulante Profilático?',
  comorbidities: 'Comorbidades',
};

const SurgeryDetailsCard = () => {
  const { patientData } = usePatient();
  const profile = patientData?.surgeryProfile;

  if (!profile) {
    return (
      <HealthCustomCard noPadding>
        <section className={styles.wrapper}>
          <p>Nenhum dado cirúrgico cadastrado.</p>
        </section>
      </HealthCustomCard>
    );
  }

  const formatValue = (key, value) => {
    if (value == null || value === '') return '-';
    if (key === 'currentSurgeryDate') return moment(value).format('DD/MM/YYYY');
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (Array.isArray(value)) return value.join(', ') || '-';
    return String(value);
  };

  const items = [
    'currentSurgeryDate',
    'tumorCid',
    'finalStaging',
    'treatmentProtocol',
    'ecog',
    'hadRadiotherapy',
    'hadSystemicTherapy',
    'currentSurgeryType',
    'accessRoutes',
    'hasStoma',
    'hasDrain',
    'usesProphylacticAnticoagulant',
    'comorbidities',
  ].map((key) => ({
    label: LABELS[key] || key,
    value: formatValue(key, profile[key]),
  }));

  return (
    <HealthCustomCard noPadding>
      <section className={styles.wrapper}>
        <div className={styles.detailCard}>
          {items.map((item, index) => (
            <div className={styles.detailCardItem} key={index}>
              <h1>{item.label}</h1>
              <div className={styles.editContainer}>
                <p>{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </HealthCustomCard>
  );
};

export default SurgeryDetailsCard;
